$(function () {
  var popupDelayId;
  var popupOnStage4 = false;
  var bmProcessing = false;
  var bankverificationWindowClosed = false;
  var popupDelayTime = 30000;

  //Setup stage 4 mouse leave/timer popup
  if ($('.verify-popup').length > 0) {
    $('.verify-popup').on('click', '.content-popup-close', function () {
      $('.verify-popup').removeClass('visible');
      //popupOnStage4 = false;
      timerPopup();
    })
    $('.verify-popup').on('click', '#frmBankVerification input[type=submit]', function (event) {
      $('.verify-popup').removeClass('visible');
      $('.loading-sceen').show();
    });

    if ($('#popup-interval').length > 0 && $('#popup-interval').data('popup-interval').length != '') {
      popupDelayTime = parseInt($('#popup-interval').data('popup-interval'));
    }

    timerPopup();
    //display popup when mouse leaves window
    $("html").on('mouseleave', function (e) {
      if (!popupOnStage4) {
        showPopup();
      }
    });
    //Reset the popup timer if user clicks or moves mouse
    $("html").on('mousemove', function (e) {
      timerPopup();
    });
    $("html").on('keypress', function (e) {
      timerPopup();
    });
    function timerPopup() {
      clearInterval(popupDelayId);
      if (!popupOnStage4) {
        popupDelayId = setInterval(function () {
          showPopup();
        }, popupDelayTime);
      }
    }
    function showPopup() {
      if (!$('.verify-popup').is(':visible')) {
        $('.verify-popup').addClass('visible');
        popupOnStage4 = true;
      }
    }
  }

  //Handle SS/1PLN agree check box behaviour
  $('body').on('click', '.agree-1', function () {
    if ($(this).is(':checked')) {
      $('.form-page-right [type="submit"]').eq(0).removeAttr('disabled').removeClass('disabled');
    } else {
      $('.form-page-right [type="submit"]').eq(0).attr('disabled', 'disabled').addClass('disabled');
    }
  });

  $("body").on("click", "#frmOnePLNVerification input[type=submit]", function (event) {
    $('.loading-sceen').show();
    OpenBMPage(1, "#frmOnePLNVerification");
  });

  $("body").on("click", "#bnkverificationForm input[type=submit]", function (event) {
    $('.loading-sceen').show();
    OpenBMPage(2, "#bnkverificationForm");
  });

  function getBMParameterValues(bmservicetype) {
    var data;
    $.ajax({
      type: 'POST',
      async: false,
      url: '/api/sitecore/PaymentGateway/GetBMVerificationRequest',
      data: { serviceType: bmservicetype },
      error: function () { },
      success: function (response) {
        data = response;
      }
    });

    return data;
  }

  function OpenBMPage(bmservicetype, formname) {

    var data = getBMParameterValues(bmservicetype);
    var bmdata = JSON.parse(data);

    //if (data == null || data.BmParameters.ErrorCode != null) {
    //    window.location.href = "#";
    //    event.preventDefault();
    //    return;[t]
    //}

    $('' + formname + ' #hdnServiceID').val(bmdata.ServiceID);
    $('' + formname + ' #hdnOrderID').val(bmdata.OrderID);
    $('' + formname + ' #hdnAmount').val(bmdata.Amount);
    $('' + formname + ' #hdnDescription').val(bmdata.Description);
    $('' + formname + ' #hdnGatewayID').val(bmdata.GatewayID);
    $('' + formname + ' #hdnCurrency').val(bmdata.Currency);
    $('' + formname + ' #hdnCustomerEmail').val(bmdata.CustomerEmail);
    $('' + formname + ' #hdnTitle').val(bmdata.Title);
    $('' + formname + ' #hdnValidityTime').val(bmdata.ValidityTime);
    $('' + formname + ' #hdnVerificationFName').val(bmdata.VerificationFName);
    $('' + formname + ' #hdnVerificationLName').val(bmdata.VerificationLName);
    $('' + formname + ' #hdnVerificationStreet').val(bmdata.VerificationStreet);
    $('' + formname + ' #hdnVerificationStreetHouseNo').val(bmdata.VerificationStreetHouseNo);
    $('' + formname + ' #hdnVerificationStreetStaircaseNo').val(bmdata.VerificationStreetStaircaseNo);
    $('' + formname + ' #hdnVerificationStreetPremiseNo').val(bmdata.VerificationStreetPremiseNo);
    $('' + formname + ' #hdnVerificationPostalCode').val(bmdata.VerificationPostalCode);
    $('' + formname + ' #hdnVerificationCity').val(bmdata.VerificationCity);
    $('' + formname + ' #hdnVerificationNRB').val(bmdata.VerificationNRB);
    $('' + formname + ' #hdnLinkValidityTime').val(bmdata.LinkValidityTime);
    $('' + formname + ' #hdnHash').val(bmdata.Hash);

    bmProcessing = true;
    var scrWidth = screen.availWidth;
    var paramWidth = (scrWidth < 750 ? scrWidth : 750);
    var paramLeft = parseInt((scrWidth - paramWidth) / 2);
    var scrHeight = screen.availHeight;
    var paramHeight = (scrWidth < 500 ? scrWidth : 500);
    var paramTop = parseInt((scrHeight - paramHeight) / 2);
    popupOnStage4 = true;
    var bmWindow = window.open('', 'BMwindow', 'width=' + paramWidth + ',height=' + paramHeight + ',top=' + paramTop + ',left=' + paramLeft + ',scrollbars=yes');
    var timer = setInterval(function () {

      if (bmWindow.closed) {
        bankverificationWindowClosed = true;
        clearInterval(timer);
        $('.loading-sceen').hide();
        popupOnStage4 = false;
        location.reload();
      }
    }, 1000);
    return true;
  }

});

export default class FormEvents {
  constructor() {
    this.dom = {
      $: window.$,
      jQuery: window.$,
      $form: $('form'),
      $mail: $('.email'),
      $sms: $('.verify-sms'),
      $confirmButtons: $('.content-popup-confirmation')
    };
    if (this.dom.$form) {
      this.init();
    }
  }

  init() {
    this.verifySmsAndRedirect();
  }

  verifySmsAndRedirect() {
    if (this.dom.$sms.length !== 0) {
      this.dom.$sms.on('keyup', (e) => {
        let $target = $(e.currentTarget);

        if ($target.val().length === 4) {
          setTimeout(() => (window.location = './gratulacje.html'), 3000);
        }
      });
    }
  }
}
